import { baseService, GLOBAL_TAG_TYPES } from '@repo/services';
import { type SmartViewTabConfigType } from '@repo/utils';

export interface CreateSmartViewPayload {
  name: string;
  description: string;
  result_type: 'lead' | 'activity' | 'task';
  criteria_group_id?: number;
  sequence_number: number;
  config: SmartViewTabConfigType;
}

const smartViewsService = baseService.injectEndpoints({
  endpoints: (build) => ({
    createSmartView: build.mutation<void, CreateSmartViewPayload>({
      query: (payload) => ({
        method: 'POST',
        url: '/v1/smart_views/tabs',
        body: payload,
      }),
      invalidatesTags: [GLOBAL_TAG_TYPES.smartViewDashboard],
    }),
    updateUserSmartView: build.mutation<void, { id: string, payload: CreateSmartViewPayload }>({
      query: (body) => ({
        method: 'PUT',
        url: `/v1/smart_views/tabs/${body.id}`,
        body: body.payload,
      }),
      invalidatesTags: [GLOBAL_TAG_TYPES.smartViewDashboard],
    }),
  }),
});

export const {
  useCreateSmartViewMutation,
  useUpdateUserSmartViewMutation,
} = smartViewsService;
